/** Grymwyrd 日本語版ホームコピー。 */
export const homeJa = {
  'home.heroEyebrow': '息づく恐怖ファンタジーの世界',
  'home.heroTitle': '黄昏へ降り立つ',
  'home.heroBody':
    'Grymwyrd はヴィクトリア朝ゴシックホラーに彩られた世界です。霧に沈む町 Greywick では廃墟と化した塔、館の地下室、そして語るべからざる儀式が息づいています。英雄を創造し、大異変の面紗を解き、忘れぬ世界へ己の名を刻みましょう。',
  'home.heroPlayCta': 'プレイを開始',
  'home.heroBrowseCta': '事典を閲覧',
  'home.heroQuickstartPrompt': 'すぐにプレイできない？無料の Quickstart をご利用ください',
}
